export default __webpack_public_path__ + "static/media/badge.4a7ae428.svg";